import { render } from "./CircleLoader.vue?vue&type=template&id=0ae7d205&scoped=true"
import script from "./CircleLoader.vue?vue&type=script&lang=js"
export * from "./CircleLoader.vue?vue&type=script&lang=js"

import "./CircleLoader.vue?vue&type=style&index=0&id=0ae7d205&lang=scss&scoped=true"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae7d205"]])

export default __exports__